// extracted by mini-css-extract-plugin
export default {"LuckyPrize":"LuckyPrize___BQdiW","list":"list___utZW2"};